<template>
  <div>
<div class="container" id="container-1">
  <div class=" privacy-style ">
   <div class="row bar">
        <div class="col-12 col-md-5">
          <div class="d-flex justify-content-between mb-1">
            <div class="col-auto bg-n-red">服務條款</div>
            <div class="col bg-n-gray text-left">SERVICE</div>

          </div>
        </div>
       
      </div>
  <p>在您正式使用「<span >久億光電科技有限公司</span>」（以下簡稱為「<span >本網站</span>」）的服務之前，請先詳閱本使用者服務條款（以下稱為「本服務條款」）。本服務條款之目的，在於盡力保護會員在使用本網站服務時的權益，並確認「本網站」與會員之間的權利義務關係。</p>
  <h3>一、接受使用條款</h3>
  <p>當您使用本服務條款時，即表示您已閱讀、瞭解並同意本服務條款之所有內容與約定，並完全接受本服務現有與未來衍生的服務項目及內容。</p>
  <p>若您於任何修改或變更之後繼續使用「本網站」之服務，即視為您已經閱讀、瞭解且同意接受修改或變更後之服務條款內容。 若您不同意上述服務條款修改變更方式，或不接受本服務條款任一條款，您應立即停止使用「本網站」之服務。</p>
  <p>如果您未滿二十歲，除應符合上述規定外，並應於您的家長(或監護人)閱讀、瞭解並同意本服務條款之所有內容及其後修改變更，才可以註冊會員、使用或繼續使用「本網站」之服務。</p>
  <h3>二、您同意並保證以下事項：</h3>
  <p>您同意不冒用他人名義使用「本網站」。<br>
依「本網站」之提示，提供正確的個人資料，且無重覆註冊等事情。若您提供任何錯誤、不實、過時或不完整或具誤導性的資料；或者「本網站」有理由懷疑前述資料為錯誤、不實、過時或不完整或具誤導性的，「本網站」有權暫停、不受理或終止您的使用權利，並拒絕您於現在和未來使用「本網站」之全部或任何部分。<br>
您同意所登錄或留存之個人資料，「本網站」可以在必要合理範圍或有助於「本網站」服務之提供，蒐集、處理、保存、傳遞及使用您的資料。<br>
隱私權政策：「本網站」對於您所登錄或留存之個人資料，在未獲得您的同意以前，都僅供「本網站」及「本網站」相關業務合作夥伴於其內部、依照原來所說明的使用目的和範圍加以使用，除非事先說明、或依照相關法律規定，否則「本網站」不會將您的個人資料提供給第三人、或移作其他目的使用。<br>
您同意不會利用「本網站」對他人進行誹謗、侮辱、威脅、猥褻、干擾、不實、違反道德與發布公共秩序之文字、圖片或任何形式的檔案於「本網站」。<br>
您同意不逕自使用、修改、重製、散布、發行、進行還原工程、解編或反向組譯「本網站」上的程式以及所有內容，包括但不限於著作、圖片、檔案、網站架構、網頁設計等，均由「本網站」或其他權利人依法擁有其智慧財產權，包括但不限於商標權、專利權、著作權與專有技術等。<br>
未得創作者許可，您不得有修改、重製、轉貼之相關情事於營利行為。若您有涉及侵權之情事，「本網站」有權停止您使用「本網站」，並取消會員資格。對違反本服務條款行為之處置您同意「本網站」得依其判斷並認定您已經違反本服務條款之情事，「本網站」有權終止或限制您使用本服務，並取消會員資格。<br>
免責聲明：當「本網站」發生系統中斷，包括但不限於保養、施工、升級、故障或天災不可抗力之因素，也許會造成您的資料遺失、使用不便或其他損失，「本網站」將不付任何賠償與責任。請您使用「本網站」時，自行採取備份措施。<br>
「本網站」不保證系統程式不發生錯誤或障礙等情事，使用者自行採取備份措施。「本網站」於任何時刻，無論是否有公告或是通知使用者，都有權修改或終止任何服務項目，以及停止使用者使用權利。<br>
「本網站」有權於任何時間基於需要而修訂或變更本服務條款之內容，並取代先前的內容，修改後之服務條款將會公告於「本網站」，恕不另行通知，建議您隨時注意該等修改或變更。<br>
</p>
</div>
</div>

      
  </div>
</template>


<script>
export default {
  data(){
    return{

      a: [
        {
          xs: "/static/service/768/1.jpg",
          sm: "/static/service/768/1.jpg",
          md: "/static/service/768/1.jpg",
          lg: "/static/service/768/1.jpg",
          xl: "/static/service/1200/1.jpg"
        }
      ]
    }
  },
  methods: {
    pusha() {
      let vm = this;
      vm.$emit("pusha", vm.a);
    }
  },
  created: function() {
    this.pusha()
  },
  mounted: function() {

  },
}
</script>

<style lang="sass" scoped>
@import "~bootstrap/scss/bootstrap"
.privacy-style
  text-align: left
  // padding-top: 65px
  // padding-bottom: 100px
  h1
    font-size: 43px
    margin-bottom: 45px
    font-weight: 700
  h3
    margin-bottom: 45px
    font-size: 22px
    font-weight: 700
  p
    line-height: 31px
    margin-bottom: 45px
    font-size: 16px
  span
    font-size: 18px
    color: rgb(175, 40, 45)
    font-weight: 600
.bar
  @include media-breakpoint-up(xl)
    margin-bottom: 50px
  @include media-breakpoint-up(xl)
    margin-bottom: 16px
.bg-n-red
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(182, 40 ,44)
  color: white
  text-align: center
  padding-top: 7px
  padding-bottom: 7px
.bg-n-gray
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(51, 58, 64)
  color: white
  padding-left: 13px
  padding-top: 7px
  padding-bottom: 7px 
#container-1
  @include media-breakpoint-up(xl)
    padding-top: 118px
    padding-bottom:  212px
  @include media-breakpoint-up(xs)
    padding-top: 46px
    padding-bottom:  146px
</style>




// WEBPACK FOOTER //
// src/components/Service.vue